import { LinkOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';

export default function CopyViewLinkButton() {
  const copyViewLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      message.success('Share link copied');
    } catch {
      message.error('Unable to copy link. Copy the URL from your address bar.');
    }
  };

  return <Button size="small" icon={<LinkOutlined />} onClick={copyViewLink}>Copy view link</Button>;
}
